import { render, staticRenderFns } from "./GroupCEOawardAdmin.vue?vue&type=template&id=f67945aa&"
import script from "./GroupCEOawardAdmin.vue?vue&type=script&lang=js&"
export * from "./GroupCEOawardAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports